import { PermissionNameEnum } from '@Types/permissions';
import Policy from '.';
import AddPolicy from './AdvancedThreatProtection/AddPolicy';
import EditPolicy from './AdvancedThreatProtection/EditPolicy';
import EditDlpPolicies from './DataLossPrevention/EditPolicy';
import AddDlpPolicy from './DataLossPrevention/AddPolicy';
import ComplianceTemplates from './DataLossPrevention/ComplianceTemplates';
import DataIdentifiers from './DataLossPrevention/DataIdentifiers';

const policyRouter = [
  {
    path: '/policy/*',
    element: Policy,
    name: 'side.group.policy',
    permission: [
      PermissionNameEnum.atpPolicy,
      PermissionNameEnum.dlpPolicy,
      PermissionNameEnum.administrator,
    ],
  },
  {
    path: '/policy/advanced-threat-protection/add-policy/:service',
    element: AddPolicy,
    name: 'side.group.policy',
    permission: PermissionNameEnum.atpPolicy,
  },
  {
    path: '/policy/advanced-threat-protection/edit-policy/:policyUuid',
    element: EditPolicy,
    name: 'side.group.policy',
    permission: PermissionNameEnum.atpPolicy,
  },
  {
    path: '/policy/data-loss-prevention/edit-policy/:policyUuid',
    element: EditDlpPolicies,
    name: 'side.group.policy',
    permission: PermissionNameEnum.dlpPolicy,
  },
  {
    path: '/policy/data-loss-prevention/add-policy/:service',
    element: AddDlpPolicy,
    name: 'side.group.policy',
    permission: PermissionNameEnum.dlpPolicy,
  },
  {
    path: '/policy/data-loss-prevention/compliance-templates',
    element: ComplianceTemplates,
    name: 'side.group.policy',
    permission: PermissionNameEnum.dlpPolicy,
  },
  {
    path: '/policy/data-loss-prevention/data-identifiers',
    element: DataIdentifiers,
    name: 'side.group.policy',
    permission: PermissionNameEnum.dlpPolicy,
  },
];

export default policyRouter;
